import { PayloadAction } from '@reduxjs/toolkit';
import { BottomSheetState } from '@reducers/v2/bottomSheet/bottomSheet.slice';

export const setSkipNavigationOnCloseAction = (state: BottomSheetState, action: PayloadAction<boolean>) => {
	state.skipNavigationOnClose = action.payload;
};
